import {Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, ViewChild} from "@angular/core";
import {TranslatableComponent} from "../../core/models/TranslatableComponent";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import {Project, SourceCodeStorage} from "../../core/models/Project";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {DataService} from "../../core/services/services/data.service";
import {AlertEnum} from "../../core/models/Enums/AlertEnum";
import {MessageService} from "../../core/services/services/message.service";
import {ProjectService} from "../../core/services/services/project.service";
import {ProjectTimeSlice, ProjectTimeSliceForm} from "../../core/models/ProjectTimeSlice";
import {ScreenRefreshService} from "../../core/services/services/refresh-screens.service";
import {ImportRefreshService} from "../../core/services/services/importDialogRefresh.service";
import {InfoDialogComponent} from "../info-dialog/components/info-dialog.component";
import Config from "../../core/config/Config";
import {CustomizingService} from "../../core/services/services/customizing.service";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {
	MatTable,
	MatTableDataSource,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from "@angular/material/table";
import {MatDrawer} from "@angular/material/sidenav";
import {
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators,
	ReactiveFormsModule,
} from "@angular/forms";
import {AuthenticationService} from "../../core/services/services/authentication.service";
import {ExtendOrMoveProjectDialogComponent} from "../dialogs/extend-or-move-project-dialog/extend-or-move-project-dialog.component";
import {CopyAssignmentsDialogComponent} from "../dialogs/copy-assignments-dialog/copy-assignments-dialog.component";
import {Client} from "../../core/config/Client";
import {AssignmentProjectEmployee} from "../../core/models/AssignmentProjectEmployee";
import {EMPTY, forkJoin, Observable} from "rxjs";
import {catchError, finalize, switchMap, tap} from "rxjs/operators";
import moment from "moment";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {AddSourceCodeDialogComponent} from "../dialogs/add-source-code-dialog/add-source-code-dialog.component";
import {Employee} from "../../core/models/Employee";
import {ProjectDataInputComponent} from "./project-data-input/project-data-input.component";
import {DateValidator} from "../../core/validation/DateValidator";
import {AddEmployeeToProjectElement} from "./add-employee-to-project/add-employee-to.project.interface";
import {EditProjectAccessDialogComponent} from "../dialogs/edit-project-access-dialog/edit-project-access-dialog.component";
import {
	EmployeeFullNameEmailStatus,
	OfferedEmployeesComponent,
} from "../dialogs/offered-employees/offered-employees.component";
import {EmployeeService} from "../../core/services/services/employee.service";
import {asyncFilter} from "../../core/util/util";
import {ConfirmationDialogComponent} from "../dialogs/confirmation-dialog/confirmation-dialog.component";
import {PageNotFoundService} from "../../core/services/services/page-not-found.service";
import {MatIcon} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {NgClass, NgStyle} from "@angular/common";
import {RequiresPermissionDirective} from "../permission/directives/requires-permission.directive";
import {MatTooltip} from "@angular/material/tooltip";
import {CrossApplicationLinkComponent} from "./cross-application-link/cross-application-link.component";
import {SaveHotkeyDirective} from "../hotkey/directives/save-hotkey.directive";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatCheckbox} from "@angular/material/checkbox";
import {
	MatAccordion,
	MatExpansionPanel,
	MatExpansionPanelHeader,
	MatExpansionPanelTitle,
} from "@angular/material/expansion";
import {MatIconButton} from "@angular/material/button";
import {MatFormField, MatSuffix, MatError, MatLabel, MatHint} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatDatepickerInput, MatDatepickerToggle, MatDatepicker} from "@angular/material/datepicker";
import {OnlyNumbersDirective} from "../inputdirectives/onlyNumbers.directive";
import {EscapeHotkeyDirective} from "../hotkey/directives/escape-hotkey.directive";
import {TruncateTextPipe} from "../pipes/pipes/truncate-text.pipe";

@UntilDestroy()
@Component({
	selector: "app-project-data",
	templateUrl: "./project-data.component.html",
	styleUrls: ["./project-data.component.scss"],
	imports: [
		MatIcon,
		MatToolbar,
		NgClass,
		RequiresPermissionDirective,
		MatTooltip,
		CrossApplicationLinkComponent,
		SaveHotkeyDirective,
		MatProgressBar,
		MatCheckbox,
		MatAccordion,
		MatExpansionPanel,
		MatExpansionPanelHeader,
		MatExpansionPanelTitle,
		MatIconButton,
		MatTable,
		MatSort,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatSortHeader,
		MatCellDef,
		MatCell,
		MatFormField,
		MatInput,
		ReactiveFormsModule,
		MatDatepickerInput,
		OnlyNumbersDirective,
		MatDatepickerToggle,
		MatSuffix,
		MatDatepicker,
		MatError,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		MatLabel,
		MatHint,
		NgStyle,
		ProjectDataInputComponent,
		EscapeHotkeyDirective,
		TranslatePipe,
		TruncateTextPipe,
	],
})
export class ProjectDataComponent extends TranslatableComponent implements OnInit, OnChanges {
	@ViewChild("table") table: MatTable<any>;
	@ViewChild(ProjectDataInputComponent) projectDataInput: ProjectDataInputComponent;

	@Output() projectSelected: EventEmitter<Project> = new EventEmitter<Project>();
	@Output() afterProjectAdded: EventEmitter<any> = new EventEmitter<any>();
	@Input() isAddMode: boolean;
	@Input() drawer?: MatDrawer;
	@Input() isReadonlyMode: boolean;
	@Input() assignedEmployeesDataSource = new MatTableDataSource<AssignmentProjectEmployee>();
	@Input() projectProbabilitiesDataSource = new MatTableDataSource<ProjectTimeSliceForm>();
	@Input() convertFromStaffingRequest = false;

	isMultiProjectSaveMode = false;
	isEditMode = false;
	project: Project = new Project();
	fixedProject: Project = new Project();
	displayedColumns: string[] = ["firstName", "lastName"];
	employeesToProjectDataSource = new MatTableDataSource<Employee>();
	isProjectDataEdited: boolean;
	projectStatusChanged: boolean;
	isEmployeeAdded: boolean;
	loading = false;
	statusOOBcheck: boolean;
	addedTimeslices = false;
	userBusinessUnit: string;
	addEmployeePanelExpanded = true;
	projectProbabilitiesDisplayedColumns: string[] = ["effectiveFrom", "effectiveUntil", "probability", "delete"];
	capaTableSort: MatSort;
	sourceCodeStorage: SourceCodeStorage;
	today = moment();
	addEmployeeToProjectElement: AddEmployeeToProjectElement;
	formGroup = new UntypedFormGroup(
		{
			effectiveFrom: new UntypedFormControl("", {
				validators: Validators.required,
			}),
			effectiveUntil: new UntypedFormControl("", {
				validators: Validators.required,
			}),
			capacity: new UntypedFormControl("", [Validators.max(100), Validators.min(0), Validators.required]),
		},
		{validators: DateValidator.fromToDate("effectiveFrom", "effectiveUntil", "forbiddenEndDate")},
	);
	private currentClient: Client;
	lastSharePointId = ["", ""];

	constructor(
		private matDialog: MatDialog,
		private _importRefreshService: ImportRefreshService,
		private t: TranslateService,
		private _fb: UntypedFormBuilder,
		private _router: Router,
		private route: ActivatedRoute,
		private _location: Location,
		public loginService: AuthenticationService,
		private _dataService: DataService,
		private _messageService: MessageService,
		private _projectService: ProjectService,
		private _screenRefreshService: ScreenRefreshService,
		private dialog: MatDialog,
		private customizing: CustomizingService,
		private employeeService: EmployeeService,
		private pageNotFoundService: PageNotFoundService,
		@Optional()
		@Inject(MAT_DIALOG_DATA)
		private _dialogData?: {
			convertFromStaffingRequest: boolean;
			isAddMode: boolean;
			isReadonlyMode: boolean;
			init: (pdc: ProjectDataComponent) => void;
		},
		@Optional() public dialogRef?: MatDialogRef<ProjectDataComponent>,
	) {
		super(t, "ProjectDataComponent");
		customizing.getCurrentClient().then((client) => {
			this.currentClient = client;
		});

		this.dialogRef?.addPanelClass("mep-dialog");

		if (this.dialogRef && this.convertFromStaffingRequest) {
			this.formGroup.markAllAsTouched();
		}
	}

	@ViewChild("capaTableSort") set setCapaTableSort(sort: MatSort) {
		this.capaTableSort = sort;
		this.projectProbabilitiesDataSource.sort = this.capaTableSort;
	}

	async ngOnInit() {
		if (this._dialogData) {
			this.openFromDialog();
		}
		if (!this.isReadonlyMode) {
			this.customizing.getExternalLinks().then((externalLinks) => {
				this.statusOOBcheck = externalLinks === "OOB" || externalLinks === "CHARISMA_OOB";
			});
			if (this.isAddMode) {
				this.addEmployeeToProjectElement = {
					employees: this.employeesToProjectDataSource.data,
					capacity: 100,
					effectiveFrom: this.today,
					effectiveUntil: null,
					addEmployeeForm: false,
				};
				this.clearAll();
				this.drawer?._closedStream.pipe(untilDestroyed(this)).subscribe(() => this.clearAll());
			} else {
				this.route.paramMap
					.pipe(
						switchMap((value) => {
							const sharePointId = value.get("id");
							this.lastSharePointId[0] = this.lastSharePointId[1];
							this.lastSharePointId[1] = sharePointId;
							if (!sharePointId) {
								this._routeToHomeScreen(false);
								return EMPTY;
							}
							const fromProjectList = this.route.snapshot.queryParamMap.get("fromProjectList") === "true";
							return this._setSelectedProjectButStay(sharePointId, fromProjectList);
						}),
						untilDestroyed(this),
					)
					.subscribe();
			}
			// Default values
			this.loginService.getApplicationUser().then((user) => {
				if (user.employee != null && user.employee.businessUnit != null) {
					// Ein bereits geladenes Projekt darf nicht überschrieben werden, falls der User erst danach geladen ist
					if (this.isAddMode || !this.project.businessUnit) {
						this.project.businessUnit = user.employee.businessUnit;
						this.project.marketUnit = user.employee.businessUnit;
					}
					this.userBusinessUnit = user.employee.businessUnit;
				} else {
					this.userBusinessUnit = "N/A";
				}
			});
		}

		this.projectProbabilitiesDataSource.sortingDataAccessor = (data: ProjectTimeSliceForm, column: string) =>
			data[column].value;

		if (this.convertFromStaffingRequest) {
			this.formGroup.get("capacity").setValue("100");
		} else {
			this.formGroup.get("capacity").setValue("100");
			this.formGroup.get("effectiveFrom").setValue(this.today);
		}
		this._dialogData?.init(this);
	}

	clearAll(): void {
		this.project = new Project();
		this.loginService.getApplicationUser().then((val) => {
			if (val.employee != null && val.employee.businessUnit != null && val.employee.businessUnit !== "MISSING_VALUE") {
				this.project.businessUnit = val.employee.businessUnit;
			}
		});
		this.employeesToProjectDataSource = new MatTableDataSource<Employee>();
		this.sourceCodeStorage = null;
		this.projectProbabilitiesDataSource.data = [];
		// Die untergeordneten Projekte liegen im Kind-Component, das beim Schließen der Seitenleiste
		// nicht neu erzeugt wird. Beim ersten Aufruf aus ngOnInit ist das ViewChild noch nicht aufgelöst.
		if (this.projectDataInput) {
			this.projectDataInput.aggregatedProjectsDataSource.data = [];
			this.projectDataInput.aggregatedProjectsUnfiltered = [];
		}
		this.addSlice();
	}

	openAddEmployeeToProjectDialog() {
		const dialogRef = this.dialog.open(OfferedEmployeesComponent, {
			data: {
				employees: this.addEmployeeToProjectElement.employees,
				fromProjectAdd: true,
			},
		});

		dialogRef.afterClosed().subscribe((result?: EmployeeFullNameEmailStatus[]) => {
			if (result) {
				this.addEmployees({
					employees: result as Employee[],
					addEmployeeForm: result.length > 0,
				} as AddEmployeeToProjectElement).then();
			}
		});
	}

	async addEmployees(result: AddEmployeeToProjectElement) {
		if (result !== undefined) {
			const invalidEmployeeNames = [];
			const employees = await asyncFilter(result.employees ?? [], async (e: Employee) => {
				if (this.project.id === undefined) return true;
				const valid = await this._projectService.canAssignEmployee(e, this.project);
				if (!valid) {
					invalidEmployeeNames.push(e.firstName + " " + e.lastName);
				}
				return valid;
			});
			if (invalidEmployeeNames.length > 0) {
				const dialogRef = this.matDialog.open(InfoDialogComponent, {
					data: invalidEmployeeNames,
				});
				dialogRef.componentInstance.dialogTitle = this.translate.instant(
					"mep.components.general.notification.add-employee-init-not-possible-title",
				);
				dialogRef.componentInstance.dialogDescription = this.translate.instant(
					"mep.components.general.notification.add-employee-init-not-possible-description",
				);
				dialogRef.componentInstance.showCopyButton = false;
			}

			this.employeesToProjectDataSource.data = employees;
			this.addEmployeeToProjectElement.employees = employees;
			this.isEmployeeAdded = result?.addEmployeeForm;
			if (employees.length > 0) {
				this.addEmployeePanelExpanded = true;
			}
		}
	}

	invalidProjectProbabilities(): boolean {
		const overlapping = this.overlappingProjectProbabilities();
		const invalidForms = this.invalidProjectProbabilityForms();
		const result = overlapping || invalidForms;

		this.projectProbabilitiesDataSource.data.forEach((p) => {
			if (p.effectiveFrom.value && !moment.isMoment(p.effectiveFrom.value)) {
				setTimeout(() => {
					p.effectiveFrom.setValue(moment(p.effectiveFrom.value));
				}, 0);
			}
			if (p.effectiveUntil.value && !moment.isMoment(p.effectiveUntil.value)) {
				setTimeout(() => {
					p.effectiveUntil.setValue(moment(p.effectiveUntil.value));
				}, 0);
			}
		});

		return result;
	}

	invalidProjectProbabilityForms(): boolean {
		return this.projectProbabilitiesDataSource.data.some((control) => control.invalid);
	}

	overlappingProjectProbabilities(): boolean {
		const probabilities: ProjectTimeSliceForm[] = this.projectProbabilitiesDataSource.data;
		return probabilities.some((p1) => probabilities.some((p2) => p1 !== p2 && this.overlapping(p1, p2)));
	}

	overlapping(timeSlice1: ProjectTimeSliceForm, timeSlice2: ProjectTimeSliceForm): boolean {
		return (
			this.contains(timeSlice1, timeSlice2.effectiveFrom.value) ||
			this.contains(timeSlice1, timeSlice2.effectiveUntil.value) ||
			this.contains(timeSlice2, timeSlice1.effectiveFrom.value) ||
			this.contains(timeSlice2, timeSlice1.effectiveUntil.value)
		);
	}

	contains(timeSlice: ProjectTimeSliceForm, date: string): boolean {
		if (date) {
			const dateMoment = moment(date);
			return (
				moment(timeSlice.effectiveFrom.value) <= dateMoment &&
				(!timeSlice.effectiveUntil.value || moment(timeSlice.effectiveUntil.value) >= dateMoment)
			);
		} else {
			return false;
		}
	}

	checkToGetProjectTimeSlices() {
		if (!this.isAddMode) {
			this._getProjectTimeSlices();
		}
	}

	activateEditMode() {
		this.isEditMode = true;
	}

	deactivateEditMode() {
		if (this.isAddMode || this.isReadonlyMode) {
			this.drawer?.close().then();
			this.dialogRef?.close();
			this.isMultiProjectSaveMode = false;
			this.addEmployeeToProjectElement.effectiveUntil = null;
			this.addEmployeeToProjectElement.employees = [];
			this.formGroup.markAsUntouched();
		} else {
			this.project = Object.assign({}, this.fixedProject);
		}
		this.isEditMode = false;
	}

	submitProject() {
		this.loading = true;

		this.checkIfProjectEndIsShortened().then((isConfirmed) => {
			if (!isConfirmed) {
				this.loading = false;
				return;
			}

			if (this.isAddMode) {
				if (this.currentClient === Client.GBP ? !this.sourceCodeStorageEmpty() : true) {
					this.addProject();
				} else {
					this.matDialog.open(ConfirmationDialogComponent, {
						disableClose: false,
						data: "mep.components.project-data.fill-out-sourcecode-storage",
					});
					this.loading = false;
				}
			} else {
				this.updateProject();
			}
		});
	}

	updateProject() {
		if (this.checkForSelectedEmployee()) {
			this._projectService.updateProject(this.project).subscribe(
				(project: any) => {
					if (project) {
						this._afterProjectSubmitted(this._lang("save_changes", {projectName: project.projectName}));
					} else {
						this._afterProjectSubmitted(project.message, AlertEnum.DANGER);
					}
					if (this.projectStatusChanged && this.statusOOBcheck) {
						this._messageService.add(this._lang("project_status_changed"), AlertEnum.SUCCESS);
						this.projectStatusChanged = false;
					}
					this.project.eVersion = project.eVersion;
					this.setTimeslicesInProject().subscribe();
				},
				(error) => {
					this.onError(error);
				},
			);
		} else {
			this.loading = false;
		}
	}

	checkIfProjectEndIsShortened(): Promise<boolean> {
		return new Promise((resolve) => {
			const isShortened = this.projectProbabilitiesDataSource.data.some((row) =>
				row.effectiveUntil?.value?.isBefore(row.originalEffectiveUntil),
			);

			if (isShortened) {
				const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
					data: "mep.components.project-data.project-duration-shortening-assignment-warning",
					disableClose: true,
				});

				dialogRef.afterClosed().subscribe((result) => {
					resolve(!!result);
				});
			} else {
				resolve(true);
			}
		});
	}

	onError(error: any) {
		if (error.status === 400 || error.status === 412) {
			this._importRefreshService.refreshScreens(true);
		}
		this.loading = false;
	}

	addEmployeeToProject() {
		if (this.addEmployeeToProjectElement?.employees?.length > 0) {
			if (!this.project.id) {
				this._messageService.add("Error: Project must be created before adding employees", AlertEnum.DANGER);
				return;
			}

			const observes: Observable<AssignmentProjectEmployee>[] = Object.values(
				this.addEmployeeToProjectElement.employees,
			)
				.map((employee) => {
					if (!employee.id) {
						return;
					}

					return this._projectService.addAssignmentProjectEmployee({
						project: Config.services.projects.baseUrl + this.project.id,
						employee: Config.services.employees.baseUrl + employee.id,
						effectiveFrom: this.addEmployeeToProjectElement.effectiveFrom,
						effectiveUntil: this.addEmployeeToProjectElement.effectiveUntil,
						capacity: this.addEmployeeToProjectElement.capacity,
					} as any);
				})
				.filter((obs) => obs !== undefined);

			if (observes.length > 0) {
				forkJoin(observes).subscribe({
					error: (error) => {
						this._messageService.add("Error adding employees to project " + error, AlertEnum.DANGER);
					},
				});
			}
		}
	}

	// Deactivate the edit mode and reset the format content

	openDrawer() {
		let title = document.getElementById("detail-title");
		title.innerText = this.t.instant("mep.components.project-data.headline-add-mode");
		this.activateEditMode();
	}

	isAssignmentBetweenProject(): boolean {
		if (!this.addEmployeeToProjectElement || !this.addEmployeeToProjectElement.employees?.length) {
			return true;
		} else {
			const employeeEffectiveFrom = moment(this.addEmployeeToProjectElement.effectiveFrom).startOf("day");
			const employeeEffectiveUntil = moment(this.addEmployeeToProjectElement.effectiveUntil).startOf("day");

			return this.projectProbabilitiesDataSource.data.some((timeSlice) => {
				const projectEffectiveFrom = moment(timeSlice.effectiveFrom.value).startOf("day");

				return (
					projectEffectiveFrom.isSameOrBefore(employeeEffectiveFrom) &&
					(!timeSlice.effectiveUntil.value ||
						moment(timeSlice.effectiveUntil.value).startOf("day").isSameOrAfter(employeeEffectiveUntil))
				);
			});
		}
	}

	allRequiredFieldIsFilled(): boolean {
		if (this.isCurrentClientGBP()) {
			return (
				this.project.division &&
				this.project.projectName &&
				this.project.divisionManager &&
				this.project.projectLeader &&
				(this.isAddMode ? this.project.status : true) &&
				(this.isAddMode ? !!this.project.projectCategory : true) &&
				(this.addEmployeeToProjectElement?.employees.length > 0
					? !this.formGroup.controls.effectiveUntil.invalid
					: true) &&
				this.projectProbabilitiesDataSource.data.length > 0
			);
		}
		if (this.isCurrentClientZT()) {
			return !!(this.project.projectName && this.project.projectLeader && this.project.status);
		}
		return (
			this.project.projectName &&
			this.project.divisionManager &&
			this.project.projectLeader &&
			(this.isAddMode ? this.project.status : true) &&
			(this.addEmployeeToProjectElement?.employees.length > 0
				? !this.formGroup.controls.effectiveUntil.invalid
				: true) &&
			this.projectProbabilitiesDataSource.data.length > 0
		);
	}

	sourceCodeStorageEmpty(): boolean {
		if (!this.sourceCodeStorage || !this.project.sourceCodeStorageLocation) {
			return true;
		}
	}

	addSlice() {
		let data = this.projectProbabilitiesDataSource.data;
		let effectiveFrom = moment();
		if (data.length > 0) {
			data.sort((a, b) => {
				if (!a.effectiveUntil.value && !b.effectiveUntil.value) {
					return 0;
				}
				if (!a.effectiveUntil.value) {
					return -1;
				}
				if (!b.effectiveUntil.value) {
					return 1;
				}
				if (moment(a.effectiveUntil.value) < moment(b.effectiveUntil.value)) {
					return -1;
				} else if (moment(a.effectiveUntil.value) > moment(b.effectiveUntil.value)) {
					return 1;
				}
				return 0;
			});
			if (data[data.length - 1].effectiveUntil.value) {
				effectiveFrom = moment(data[data.length - 1].effectiveUntil.value).add(1, "days");
			}
		}
		data.push(
			new ProjectTimeSliceForm({
				effectiveFrom,
				effectiveUntil: "",
				probability: 100,
			} as any),
		);
		this.projectProbabilitiesDataSource.data = data;
		this.fixDateFormats();
		if (this.table) {
			this.table.renderRows();
		}
	}

	deleteSlice(timeSlice: ProjectTimeSliceForm) {
		let employeesWithAssignmentInDeletedTimeSlice: string[] =
			ProjectService.checkAssignmentsAndProjectTimeSliceFormsForOverlapping(
				timeSlice,
				this.assignedEmployeesDataSource,
			);
		if (employeesWithAssignmentInDeletedTimeSlice.length > 0) {
			let componentInstance = this.dialog.open(InfoDialogComponent, {
				data: employeesWithAssignmentInDeletedTimeSlice,
			}).componentInstance;
			componentInstance.dialogTitle = "Information";
			componentInstance.dialogDescription = this.translate.instant("mep.services.project-service.description");
		}
		let data = this.projectProbabilitiesDataSource.data;
		data.splice(data.indexOf(timeSlice), 1);
		this.projectProbabilitiesDataSource.data = data;
		this.table.renderRows();
	}

	openChangeProjectEndDialog(): void {
		const dialogRef = this.matDialog.open(ExtendOrMoveProjectDialogComponent, {
			disableClose: true,
			width: "1000px",
			data: this.project,
		});

		this.initOnClose(dialogRef);
	}

	openCopyAssignmentsDialog(): void {
		const dialogRef = this.matDialog.open(CopyAssignmentsDialogComponent, {
			disableClose: true,
			width: "1000px",
			data: this.project,
		});

		this.initOnClose(dialogRef);
	}

	openManageDialog() {
		this.matDialog.open(EditProjectAccessDialogComponent, {
			disableClose: false,
			width: "1000px",
			data: {
				sharePointId: this.route.snapshot.paramMap.get("id"),
				projectLeader: this.project.projectLeader.id,
			},
		});
	}

	initOnClose(dialogRef: MatDialogRef<any>) {
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.ngOnInit();
			}
		});
	}

	checkNull(value: number) {
		if (value) {
			return value + "%";
		} else {
			return "";
		}
	}

	setSourceCodeStorage() {
		this.project.sourceCodeStorageLocation = this.sourceCodeStorage?.sourceCodeStorageLocation;
		this.project.stackIntegratedStorage = this.sourceCodeStorage?.stackIntegratedStorage;
		this.project.msgHub = this.sourceCodeStorage?.msgHub;
		this.project.cloudSourceStorage = this.sourceCodeStorage?.cloudSourceStorage;
		this.project.reasonForOtherCloudSource = this.sourceCodeStorage?.reasonForOtherCloudSource;
	}

	openSourceCodeDialog() {
		const dialogRef = this.dialog.open(AddSourceCodeDialogComponent, {
			data: {
				project: this.project,
				sourceCodeStorage: this.sourceCodeStorage,
			},
			disableClose: true,
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.sourceCodeStorage = result;
				this.setSourceCodeStorage();
			}
		});
	}

	ngOnChanges(): void {
		if (this.isReadonlyMode) {
			this.isAddMode = false;
			this.isEditMode = false;
			this._dataService.currentProject.pipe(untilDestroyed(this)).subscribe((project) => {
				if (project) {
					this._setSelectedProject(project.sharePointId);
				}
			});
		}
	}

	isCurrentClientGBP(): boolean {
		return this.currentClient === Client.GBP;
	}

	isCurrentClientZT(): boolean {
		return this.currentClient === Client.ZT;
	}

	showSourceCodeStorageLocation() {
		if (this.project.sourceCodeStorageLocation === "CLIENT_RESPONSIBILITY") {
			return this._lang("attributes.client_responsibility");
		} else if (this.project.sourceCodeStorageLocation === "BUSINESSUNIT_RESPONSIBILITY") {
			return this._lang("attributes.businessunit_responsibility", {responsibleBusinessUnit: this.userBusinessUnit});
		} else if (this.project.sourceCodeStorageLocation === "NO_SOURCE_CODE") {
			return this._lang("attributes.no_source_code");
		}
	}

	inputModelChanged(newItem: string) {
		if (newItem) {
			this.isProjectDataEdited = true;
		}
	}

	onProjectStatusChanged(projectStatus: string) {
		if (projectStatus) {
			this.projectStatusChanged = true;
		}
	}

	onProjectUpdated(updatedProject: Project) {
		if (!updatedProject) return;
		this.project = updatedProject;

		if (this.project?.sourceCodeStorageLocation) {
			this.sourceCodeStorage = {
				sourceCodeStorageLocation: this.project.sourceCodeStorageLocation,
				stackIntegratedStorage: this.project.stackIntegratedStorage,
				msgHub: this.project.msgHub,
				cloudSourceStorage: this.project.cloudSourceStorage,
				reasonForOtherCloudSource: this.project.reasonForOtherCloudSource,
			} as SourceCodeStorage;
		}
	}

	setEffectiveFromDate(event: any) {
		this.addEmployeeToProjectElement.effectiveFrom = event.value;
		if (
			!this.addEmployeeToProjectElement.effectiveUntil ||
			Date.parse(this.addEmployeeToProjectElement.effectiveFrom) >
				Date.parse(this.addEmployeeToProjectElement.effectiveUntil)
		) {
			this.addEmployeeToProjectElement.effectiveUntil = this.addEmployeeToProjectElement.effectiveFrom;
		}
	}

	setEffectiveUntilDate(event: any) {
		this.addEmployeeToProjectElement.effectiveUntil = event.value;
		if (
			Date.parse(this.addEmployeeToProjectElement.effectiveFrom) >
			Date.parse(this.addEmployeeToProjectElement.effectiveUntil)
		) {
			this.addEmployeeToProjectElement.effectiveFrom = this.addEmployeeToProjectElement.effectiveUntil;
		}
	}

	setCapacity(newValue) {
		this.addEmployeeToProjectElement.capacity = newValue;
	}

	toggleMultiProjectSaveMode() {
		this.isMultiProjectSaveMode = !this.isMultiProjectSaveMode;
	}

	private _routeToHomeScreen(showErrorMessage: boolean = true, unknownProjectID: string = null) {
		if (showErrorMessage) {
			this._messageService.add(this._lang("no_project_found", {projectID: unknownProjectID}), AlertEnum.DANGER);
		}
		this._router.navigate(["homescreen"]);
	}

	// A PL wants to go in a project where he is not PL
	// Only 1 error message + go back to project-list
	private _setSelectedProjectButStay(sharePointId: string, fromProjectList: boolean): Observable<Project> {
		this.loading = true;
		return this._projectService.getProjectData(sharePointId).pipe(
			tap((project) => {
				this.project = Object.assign({}, project);
				this.fixedProject = Object.assign({}, project);
				this._afterProjectSelected();
			}),
			catchError((err) => {
				if (err.status === 403) {
					const dialogRef = this.dialog.open(InfoDialogComponent, {
						data: this.translate.instant("mep.components.edit-project-access-dialog.access-denied-project"),
					});
					dialogRef.componentInstance.dialogTitle = this.translate.instant("mep.services.error-handler.server.403");
					dialogRef.componentInstance.showCopyButton = false;
					dialogRef.afterClosed().subscribe(() => {
						if (fromProjectList) {
							this._router.navigate(["project-list"]);
						} else {
							this._location.back();
						}
					});
				} else if (fromProjectList || this.lastSharePointId[0].length === 0) {
					this.pageNotFoundService
						.navigateTo({
							status: 404,
							type: "project",
							action: "/project-list",
						})
						.then();
				} else {
					this._router.navigate(["/" + Config.services.projects.projectEdit + this.lastSharePointId[0]]);
				}
				return EMPTY;
			}),
			finalize(() => (this.loading = false)),
		);
	}

	private _setSelectedProject(sharePointId: string) {
		this.loading = true;
		this._projectService
			.getProjectData(sharePointId)
			.subscribe(
				(project) => {
					this.project = Object.assign({}, project);
					this.fixedProject = Object.assign({}, project);
					this._afterProjectSelected();
				},
				() => this._routeToHomeScreen(true, sharePointId),
			)
			.add(() => (this.loading = false));
	}

	private _afterProjectSelected() {
		this._getProjectTimeSlices();
		this.projectSelected.emit(this.project);
		this.projectDataInput.fetchAggregatedProjects(this.project);
	}

	private _getProjectTimeSlices() {
		if (!this.isAddMode || this.addedTimeslices || this.isReadonlyMode) {
			this.loading = true;
			this._projectService.getProjectProbabilities(this.project, this.isAddMode).then(
				(timeSlices: ProjectTimeSlice[]) => {
					this.projectProbabilitiesDataSource.data = timeSlices.map((timeSlice) => new ProjectTimeSliceForm(timeSlice));
					this.fixDateFormats();
					this.loading = false;
				},
				() => {
					this.projectProbabilitiesDataSource.data = [];
					this.loading = false;
				},
			);
			this.addedTimeslices = false;
		}
	}

	private addProject() {
		if (this.checkForSelectedEmployee()) {
			this._projectService.createProject(this.project).subscribe({
				next: (project: any) => {
					this.project.id = project.id;
					this.addProjectCreatorToEmployeesWithAccess(this.project.id);
					const projectLeader: Employee = this.project.projectLeader;
					this._projectService.hasProjectLeaderRole(projectLeader.id).subscribe((hasRole: boolean) => {
						if (!hasRole) {
							const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
								disableClose: false,
								data: {
									messageKey: "mep.components.project-data.create-project-leader-role",
									params: {name: projectLeader.lastName + ", " + projectLeader.firstName},
								},
							});
							dialogRef.afterClosed().subscribe((value) => {
								if (value) {
									this._projectService.createProjectLeaderRole(projectLeader.id).subscribe();
								}
							});
						}
					});
					this.setTimeslicesInProject().subscribe(() => {
						project
							? this._afterProjectSubmitted(this._lang("create-new", {projectName: project.projectName}))
							: this._afterProjectSubmitted(project.message, AlertEnum.DANGER);
						if (this.projectDataInput.aggregatedProjectsDataSource.data.length > 0) {
							forkJoin(
								this.projectDataInput.aggregatedProjectsDataSource.data.map((addedProject) =>
									this._projectService.setAggregate(project.id, addedProject.id),
								),
							).subscribe({
								next: () => {
									this._messageService.add(
										this.translate.instant("mep.services.employee.project-aggregate-success"),
										AlertEnum.SUCCESS,
									);
								},
								error: () => {
									this._messageService.add(
										this.translate.instant("mep.services.employee.project-aggregate-failed"),
										AlertEnum.DANGER,
									);
								},
							});
						}
					});
				},
				error: (error) => {
					this.onError(error);
				},
			});
		} else {
			this.loading = false;
		}
	}

	async addProjectCreatorToEmployeesWithAccess(projectId: number) {
		const currentUser = await this.loginService.getApplicationUser();
		const loginUser = currentUser?.employee;

		if (!loginUser) {
			return;
		}
		const creatorIsProjectLeader = this.project?.projectLeader?.id === loginUser.id;

		const hasProjectAdminRole = this.loginService.isProjectAdmin();

		const hasOtherElevatedAccess =
			this.loginService.isMepAdmin() ||
			this.loginService.isBusinessUnitLeader() ||
			this.loginService.isBusinessUnitManager() ||
			this.loginService.isDepartmentManager() ||
			this.loginService.isDivisionManager() ||
			this.loginService.isExecutive();

		if (!creatorIsProjectLeader && (hasProjectAdminRole || !hasOtherElevatedAccess)) {
			this.employeeService.saveCreator(projectId, loginUser).subscribe();
		}
	}

	private checkForSelectedEmployee(): boolean {
		// because ZT has not divisionManager as required field
		if (this.isCurrentClientZT()) {
			return true;
		}
		// Allow undefined project leader because after imports there may are some projects without project leader
		// and it should be possible to edit there time slices.
		if (this.project.projectLeader === null) {
			return true;
		}
		if (this.project.projectLeader && this.project.projectLeader._links === undefined) {
			this._messageService.add(this._lang("project_leader_error"), AlertEnum.DANGER);
			return false;
		}
		if (this.project.divisionManager === null || this.project.divisionManager === undefined) {
			this._messageService.add(this._lang("division_manager_error"), AlertEnum.DANGER);
			return false;
		}
		if (this.project.divisionManager && !this.project.divisionManager._links && !this.project.divisionManager.id) {
			this._messageService.add(this._lang("division_manager_error"), AlertEnum.DANGER);
			return false;
		}
		return true;
	}

	private setTimeslicesInProject(): Observable<any> {
		return this._projectService
			.putProjectTimeSlices(
				this.project.id,
				this.projectProbabilitiesDataSource.data.map((form) => form.getRawValue()),
			)
			.pipe(
				tap((result) => {
					this.projectProbabilitiesDataSource.data = result.map((timeSlice) => new ProjectTimeSliceForm(timeSlice));

					if (this.project.id && !this.isAddMode) {
						// Fetch project again because the editing of project time slices could have caused an update of project start, end and probability
						// See ProjectTimeSliceService::syncProjectBoundsAndProbability in the BE
						this._setSelectedProject(this.project.sharePointId);
					}
				}),
				finalize(() => this.afterProjectAdded.emit()),
			);
	}

	private _afterProjectSubmitted(message: string, messageType: AlertEnum = AlertEnum.SUCCESS) {
		if (this.isAddMode) {
			this.addEmployeeToProject();
		}
		if (!this.isMultiProjectSaveMode) {
			if (this.isAddMode) {
				this.drawer?.close();
				this.dialogRef?.close();
			}
			this.isEditMode = false;
			if (this.addEmployeeToProjectElement !== undefined) {
				this.addEmployeeToProjectElement.effectiveUntil = null;
				this.addEmployeeToProjectElement.employees = [];
			}
			this.formGroup.markAsUntouched();
		} else {
			this.project.projectName = "";
		}
		this._messageService.add(message, messageType);
		this.loading = false;
		this.projectProbabilitiesDataSource?.data.forEach((control) => control.markAsPristine());
		this.isProjectDataEdited = false;
		if (this.sourceCodeStorage) {
			this.sourceCodeStorage.sourceCodeForm = false;
		}
	}

	private openFromDialog() {
		this.convertFromStaffingRequest = this._dialogData.convertFromStaffingRequest;
		this.isAddMode = this._dialogData.isAddMode;
		this.isReadonlyMode = this._dialogData.isReadonlyMode;
	}

	onEffectiveFromChange(event: any, row: any) {
		if (event.value && !moment.isMoment(event.value)) {
			row.effectiveFrom.setValue(moment(event.value));
		}
	}

	fixDateFormats() {
		this.projectProbabilitiesDataSource.data.forEach((row) => {
			row.originalEffectiveUntil = row.effectiveUntil.value?.clone();
			if (row.effectiveFrom.value && !moment.isMoment(row.effectiveFrom.value)) {
				row.effectiveFrom.setValue(moment(row.effectiveFrom.value));
			}
			if (row.effectiveUntil.value && !moment.isMoment(row.effectiveUntil.value)) {
				row.effectiveUntil.setValue(moment(row.effectiveUntil.value));
			}
		});
	}

	protected readonly CustomizingService = CustomizingService;
}
